import React, { useContext, useState, useEffect, useMemo } from 'react';
import {
  Widget,
  FormSelect,
  SimpleView,
  MasterDetailForm,
  GridView,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
  Table,
  FormText,
  Button,
  FormInput,
} from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon, Input } from 'antd';
import { ResumoCapex } from '@app/api/ordemInvestimento';

interface FormResumoCapexProps {
  resumoCapex: ResumoCapex[];
  projetoId: string;
  //resumoHeader: string;
}

const { Panel } = Collapse;

const FormTableOrcadoCapexProjeto = (props: FormResumoCapexProps) => {
  const { resumoCapex, projetoId } = props;

  const [resumoHeader, setResumoHeader] = useState<string>();
  const [valorTotal, setValorTotal] = useState<string>();
  const [vazio, setVazio] = useState<string>();


  useEffect(() => {
    const getData = () => {
      if (resumoCapex.length > 0) {
        var capex = resumoCapex[0];
        if (capex) {          
          var header = capex.numero + ' - ' + capex.revisao + ' - ' + capex.dataAprovacao;
          setResumoHeader(header);
          setValorTotal(capex.valorTotalCurrency);
        }
      }
    };

    getData();
  }, [resumoCapex]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Oi',
        dataIndex: 'oi',
        width: '2%',
      },
      {
        title: 'Código do pacote',
        dataIndex: 'codigoPacote',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
      },
      {
        title: 'Valor Capex',
        dataIndex: 'valorTotalCurrency',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorCurrency',
            width: '1%',
          },
        ],
      },
    ] as InlineEditColumnProps<ResumoCapex>[];
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo orçado Capex" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                projetoId && (
                  <Button
                    title="CONSULTAR DISTRIBUIÇÃO CAPEX"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/moduloOrcado/planilhaCapex/detail/${projetoId}`;
                    }}
                  />
                ),
              ]}>
              <Row>
                {resumoHeader && (
                  <FormInput label="Planilha CAPEX atual" name="numero" value={resumoHeader || ''} span={3} disabled />
                )}
              </Row>
              <Row>
                <FormText label="" name="n" />
              </Row>
              <Row>
                <Table rowKey="index" columns={customColumns()} dataSource={resumoCapex || []} />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableOrcadoCapexProjeto;
